<template>
    <div class="page page-center">
        <div class="container-tight py-4">
            <div class="text-center mb-4">
                <a href="/">
                    <span v-html="require('@/assets/img/logo.svg').default" class="main-logo" />
                </a>
            </div>
            <form class="card card-md" @submit.prevent="login">
                <div class="card-body">
                    <h2 class="card-title text-center mb-4">Sign in</h2>
                    <div class="mb-3">
                        <label class="form-label">Email address</label>
                        <input type="email" class="form-control" placeholder="Enter email" v-model="email" required />
                    </div>
                    <div class="form-footer">
                        <div class="buttons">
                            <button type="submit" class="btn btn-primary w-100" :disabled="loading">Sign in</button>
                        </div>
                    </div>

                    <div class="mt-3 text-secondary">
                        By signing in you are agreeing to the <a href="/terms-of-service" target="_blank" class="text-primary">Terms of Service</a>
                        and <a href="/privacy-policy" target="_blank" class="text-primary">Privacy Policy</a>.
                    </div>
                </div>
            </form>

            <div class="text-center text-secondary mt-3">
                Don't have account yet?
                <router-link :to="{ 'name': 'sign-up' }">Sign up</router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["next"],
    data() {
        return {
            email: "",
            loading: false
        };
    },
    methods: {
        login() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.$store.dispatch("auth/login", { email: this.email }).then(() => {
                this.$router.push({ name: "code", query: { email: this.email, next: this.next } });
            }).catch(e => {
                this.flashError(e);
            }).finally(() => {
                this.loading = false;
            });
        }
    }
};
</script>
